import { Auth } from '@aws-amplify/auth';
import { signInEvent } from '@growmark/cognito-vue/plugin/logic';
/** gets current users claims using standard api calls */
export const claims = (async () => {
    try {
        await signInEvent;
        const session = await Auth.currentSession();
        const { email, phone, given_name, family_name, name } = session.getIdToken().payload;
        const user = { email, phone, given_name, family_name, name };
        return user;
    }
    catch (_a) {
        return undefined;
    }
})();
export default Auth;
//# sourceMappingURL=index.js.map